var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7481 1.63143C12.7481 1.63143 10.0406 4.99955 7.5 4.99955H2.5C2.36739 4.99955 2.24021 5.05223 2.14645 5.146C2.05268 5.23977 2 5.36695 2 5.49955V8.49955C2 8.63216 2.05268 8.75934 2.14645 8.85311C2.24021 8.94688 2.36739 8.99955 2.5 8.99955H7.5C10.0406 8.99955 12.7481 12.3817 12.7481 12.3817C12.9375 12.6317 13.5 12.4605 13.5 12.0746V1.93705C13.5 1.55237 12.9688 1.34893 12.7481 1.63143Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8C2 8 1.5 7.8125 1.5 7C1.5 6.1875 2 6 2 6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.6875C14 7.6875 14.5 7.55219 14.5 7C14.5 6.44781 14 6.3125 14 6.3125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5V9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5V9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9V14.25C4.5 14.3163 4.52634 14.3799 4.57322 14.4268C4.62011 14.4737 4.6837 14.5 4.75 14.5H6.40625C6.48458 14.5 6.56181 14.4816 6.63173 14.4464C6.70165 14.4111 6.7623 14.3598 6.8088 14.2968C6.85529 14.2338 6.88632 14.1607 6.8994 14.0835C6.91247 14.0062 6.90722 13.927 6.88406 13.8522C6.62219 13.0122 6 12.065 6 10.5H6.5C6.63261 10.5 6.75979 10.4473 6.85355 10.3536C6.94732 10.2598 7 10.1326 7 10V9.5C7 9.36739 6.94732 9.24021 6.85355 9.14645C6.75979 9.05268 6.63261 9 6.5 9H6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.6ae2f5c4103b6315dbfd5d0158d468ef.svg";
export { ForwardRef as ReactComponent };